import React, { useCallback, useEffect, useState } from "react";
import Table from "../../../Table";
import SelectInput from "../../../selectInput";
import NoData from "../../../noData";
import useInfiniteScroll from "../../../Hooks/useInfiniteScroll";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { GetLoan, UpdateLoan } from "../../../../redux/Loan/action";
import dayjs from "dayjs";
import { getPayment } from "../../../../redux/payment/action";
import Modal from "../../../modal";
import { BsCurrencyPound } from "react-icons/bs";

const LoanTable = ({ searchValue }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
  });

  const [selectedRowData, setSelectedRowData] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);
  const [loading, setLoading] = useState(false);

  // Other states
  const [paymentPage, setPaymentPage] = useState(20);

  const tableData = useSelector((state) => state?.Loan?.getLoan?.data);

  const getPaymentData = useSelector(
    (state) => state?.Payment?.getPayment?.data
  );

  const paymentOption = getPaymentData?.map((e) => {
    return {
      lable: e?.paymentmethod,
      value: e?._id,
    };
  });

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const selectedRowData = tableData[index];
    const rowId = selectedRowData?._id;

    // Store the selected data in state and open modal
    setSelectedRowData({
      ...selectedRowData,
      [name]: value,
      rowId,
    });

    setModalVisible(true);
  };

  const handleApproval = async () => {
    if (selectedRowData) {
      const updatedData = {
        id: selectedRowData.rowId,
        ...selectedRowData,
      };

      try {
        setLoading(true);
        await dispatch(UpdateLoan(updatedData)).then((res) => {
          if (res?.status === 200) {
            dispatch(
              GetLoan({
                page: filter?.page,
                limit: filter?.limit,
                vendorname: searchValue,
              })
            );
            setLoading(false);
          } else if (res?.status === 401) {
            setLoading(false);
            navigate("/");
          }
        });
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.log("error", error);
      } finally {
        setLoading(false);
        setModalVisible(false); // Close the modal after processing
      }
    }
  };

  const fetchMoreOptions = useCallback(() => {
    dispatch(
      getPayment({ page: 1, limit: paymentPage, search: searchValue })
    ).then((res) => {
      if (res?.status === 200) {
        setPaymentPage((prev) => prev + 10);
      }
    });
  }, [dispatch, paymentPage, searchValue]);


  const tableHeading = {
    no: <div className="ml-5 text-center ">No.</div>,
    type: <div className="text-center ">Type</div>,
    date: <div className="text-center ">Date</div>,
    amount: <div className="text-center ">Amount</div>,
    name: <div className=" px-2">Vendor Name</div>,
    paymentMethod: <div className="text-center ">Payment Method</div>,
    payofMethod: <div className="mr-5 text-center ">Pay off Method</div>,
  };

  const headData = Object.values(tableHeading);

  const bodyData = tableData?.map((e, index) => {
    return {
      no: <div className="ml-5 text-center ">{index + 1}</div>,
      type: <div className="text-center ">{e?.type?.loantype}</div>,
      date: (
        <div className="text-center ">
          {dayjs(e?.date).format("DD/MM/YYYY")}
        </div>
      ),
      amount: (
        <div className="text-center flex items-center justify-center gap-0.5">
          <BsCurrencyPound /> {e?.amount}
        </div>
      ),
      name: <div className="  px-2">{e?.vendorname?.name}</div>,
      paymentMethod: (
        <div className="text-center ">{e?.paymentmethod?.paymentmethod}</div>
      ),
      payofMethod: (
        <div className="mr-5 text-center">
          {e?.payoffmethod?.paymentmethod ? (
            e?.payoffmethod?.paymentmethod
          ) : (
            <SelectInput
              className={"w-60"}
              option={paymentOption}
              onChange={(e) => handleChange(e, index)}
              name={"payoffmethod"}
              fetchMoreOptions={fetchMoreOptions}
            />
          )}
        </div>
      ),
    };
  });

  const fetchMoreData = useCallback(() => {
    if (hasMoreData) {
      setFilter((prev) => ({ ...prev, limit: prev.limit + 10 }));
    }
  }, [hasMoreData]);

  const lastElementRef = useInfiniteScroll(fetchMoreData);

  useEffect(() => {
    dispatch(
      GetLoan({
        page: filter?.page,
        limit: filter?.limit,
        vendorname: searchValue,
      })
    ).then((res) => {
      if (res?.data?.status === 401) {
        navigate("/");
      }
      if (res?.data?.data?.length === 0) {
        setHasMoreData(false);
      }
    });
  }, [dispatch, navigate, filter, searchValue]);

  return (
    <>
      {tableData?.length > 0 ? (
        <Table
          tableHeading={headData}
          tableData={bodyData}
          headingClass={"text-left"}
          lastElementRef={lastElementRef}
        />
      ) : (
        <NoData />
      )}

      <Modal
        loading={loading}
        modalWidth="w-1/3"
        isOpen={modalVisible}
        setIsOpen={setModalVisible}
        openModal={() => setModalVisible(true)}
        closeModal={() => setModalVisible(false)}
        imgSrc="/images/approval.svg"
        title="Approval"
        btn1="No I Don’t"
        btn2="Yes I Do"
        btnClass={"justify-end"}
        modalContent={
          <p className="text-lg font-medium">
            Would you like to Approve this payment
          </p>
        }
        handleBtn2={handleApproval} // Call handleApproval on "Yes I Do"
      />
    </>
  );
};

export default LoanTable;
